import images from "../images";

const ProductData = [
  {
    id: "lims",
    path: "/product/lims",
    pageContent: {
      channelPartnerSection: {
        Heading: {
          SectionTitle: "The price will be as low as Rs.500",
          SubHeading: "",
          align: "left",
        },
        paragraph:
        " LIMS is offered on monthly subscription prices that starts as low as 500/- per month.",
        buttons: [
          {
            label: "Reach Us",
            path: "/contact",
            type: "secondary",
          },
        ],
        aboutImg:{
          img:images.lims.cost,
          alt:'img'
        }
      },
      PageBanner: {
        SubTitle: "See what's new",
        PageHeading: "LIMS",
        PageParagraph:
          "With the help of Vaidyo's array of laboratory automation solutions, you can increase productivity, efficiency, data integrity, and compliance in your lab.",
      },
      MiddleContent: [
        {
          id: 1,
          content: {
            sideOne: {
              order: "order-1",
              content: {
                Heading: {
                  SectionTitle:
                    "Lab Information Management System",
                  align: "start",
                },
                Text: [
                  {
                    value:
                      "A powerful laboratory information management system is available at your fingertips. Learn how Vaidyo’s innovative LIMS platform provides your lab with the tools necessary to advance with confidence and speed.",
                  },
                  {
                    value:
                      "Digitally transform your pathology lab for effortless information management & a superior patient experience with our robust LIMS system.",
                  },
                  {
                    value:
                      "Learn how Vaidyo’s innovative LIMS platform provides your lab with the tools necessary to advance with confidence and speed. ",
                  },
                ],
              },
            },
            sideTwo: {
              order: "order-2",
              data: {
                Pics: {
                  img: images.lims.lims1,
                  alt: "vaidyo",
                },
              },
            },
          },
        },
        {
          id: 2,
          content: {
            sideOne: {
              order: "order-2",
              content: {
                Heading: {
                  SectionTitle: " About Vaidyo LIMS",
                  align: "start",
                },
                Text: [
                  {
                    value:
                      "LIMS has a comprehensive solution for lab, data and process management. Quickly build workflows which map to actual laboratory processes.",
                  },
                  {
                    value:
                      "Complete order administration, Custom Reports, Smart Notifications, Credit Settlement, thorough MIS Reports, and Analytics are all managed by Vaidyo's Comprehensive Lab Management.  ",
                  },
                  {
                    value:
                      "By keeping track of data pertaining to samples, experiments, laboratory workflows, and equipment, LIMS is a type of software created to increase lab productivity and efficiency.  ",
                  },
                ],
              },
            },
            sideTwo: {
              order: "order-1",
              data: {
                Pics: {
                  img: images.lims.lims2,
                  alt: "vaidyo",
                },
              },
            },
          },
        },
        {
          id: 3,
          content: {
            sideOne: {
              order: "order-1",
              content: {
                Heading: {
                  SectionTitle: "What LIMS Has",
                  align: "start",
                },
                Text: [
                  {
                    value:
                      "Increased margins, lab efficiency, quicker turnaround times, and a decrease in errors will help you grow and scale your business. ",
                  },
                  {
                    value:
                      "Real-time Queues and Customizable Reporting Templates, What’s app reporting User-friendly UI that is intuitive and simple to use.Greater effectiveness and assistance from beginning to end.",
                  },
                  {
                    value:
                      "Extensive search capabilities for patients, tests, customers, and data within the LIMS Real-time queues for each lab role that represent workloads for the day. ",
                  },
                ],
              },
            },
            sideTwo: {
              order: "order-2",
              data: {
                Pics: {
                  img: images.lims.lims3,
                  alt: "vaidyo",
                },
              },
            },
          },
        },
        {
          id: 4,
          content: {
            sideOne: {
              order: "order-2",
              content: {
                Heading: {
                  SectionTitle:
                    "Vaidyo LIMS",
                  align: "start",
                },
                Text: [
                  {
                    value:
                      "When it comes to automating processes and keeping track of all the crucial sample data, workflows, and QA/QC findings your lab produces every day, our LIMS functions as an additional team member.",
                  },
                  {
                    value:
                      "From a tracking system for samples to the digital nerve centre of the lab, LIMS has seen significant development. It is a device that aids in managing costs and efficiency.",
                  },
                  {
                    value:
                      "Your sample information, scientific data, and outcomes are not the only things that our LIMS keeps track of. You may actively control every aspect of your laboratory workflow, from sample management and instrument upkeep to personnel management and consumables.                       ",
                  },
                
                ],
              },
            },
            sideTwo: {
              order: "order-1",
              data: {
                Pics: {
                  img: images.lims.lims1,
                  alt: "vaidyo",
                },
              },
            },
          },
        },
      ],
      PricingSection: {
        Heading: {
          SectionTitle: "Designed for business teams like yours",
          SubHeading:
            "Here at Flowbite we focus on markets where technology, innovation, and capital can unlock long-term value and drive economic growth.",
          align: "center",
        },
        Cards: [
          {
            id: 1,
            Package: "Starter",
            Description: "Best option for personal use & for your next project",
            Pricing: {
              Price: "$29",
              Tenure: "/month",
            },
            CheckList: [
              {
                id: 1,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 2,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 3,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 4,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 5,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 6,
                icon: images.icons.check,
                text: "Individual configuration",
              },
            ],
            Buttons : {
                id : 1,
                path : '/',
                link : 'Get Started'
            }
          },
          {
            id: 1,
            Package: "Individual",
            Description: "Best option for personal use & for your next project",
            Pricing: {
              Price: "$99",
              Tenure: "/month",
            },
            CheckList: [
              {
                id: 1,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 2,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 3,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 4,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 5,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 6,
                icon: images.icons.check,
                text: "Individual configuration",
              },
            ],
            Buttons : {
                id : 1,
                path : '/',
                link : 'Get Started'
            }
          },
          {
            id: 1,
            Package: "Professional",
            Description: "Best option for personal use & for your next project",
            Pricing: {
              Price: "$199",
              Tenure: "/month",
            },
            CheckList: [
              {
                id: 1,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 2,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 3,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 4,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 5,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 6,
                icon: images.icons.check,
                text: "Individual configuration",
              },
            ],
            Buttons : {
                id : 1,
                path : '/',
                link : 'Get Started'
            }
          },
        ],
      },
    },
  },
  {
    id: "hms",
    path: "/product/hms",
    pageContent: {
      PageBanner: {
        SubTitle: "See what's new",
        PageHeading: "HMS",
        PageParagraph:
          "Hospital management software is a vital tool for business administration and management of sales.",
      },
      MiddleContent: [
        {
          id: 1,
          content: {
            sideOne: {
              order: "order-2",
              content: {
                Heading: {
                  SectionTitle:
                    "What is Hospital Management System (HMS)",
                  align: "start",
                },
                Text: [
                  {
                    value:
                      "Vaidyo’s Hospital management system is a software application assists in managing health-related information and effectively supports the work of healthcare providers. ",
                  },
                  {
                    value:
                      "We oversee the data for all healthcare departments, including, Financial	Clinical,	Laboratory,InpatientOutpatient, Operation theatre, Nursing, Pharmacy, Radiology, Pathology ",
                  },
                  {
                    value:
                      "With Vaidyo’s HMS, patient demands are met while the management of healthcare begins in the patients' hands via their mobile devices.",
                  },
                ],
              },
            },
            sideTwo: {
              order: "order-1",
              data: {
                Pics: {
                  img: images.innerhms.innerhms1,
                  alt: "vaidyo",
                },
              },
            },
          },
        },
        {
          id: 2,
          content: {
            sideOne: {
              order: "order-1",
              content: {
                Heading: {
                  SectionTitle:
                    " Why is a hospital's use of Vaidyo’s HMS important? .",
                  align: "start",
                },
                Text: [
                  {
                    value:
                      "Vaidyo developed HMS to address the challenges associated with maintaining all sorts of paperwork related to patients across the many hospital departments of the hospital.",
                  },
                  {
                    value:
                      "Complete order administration, Custom Reports, Smart Notifications, Credit Settlement, thorough MIS Reports, and Analytics are all managed by Vaidyo's Comprehensive hospital Management. ",
                  },
                  {
                    value:
                      "Maintaining all the patient's medical records and Saving the insurance details for future use.",
                  },
                ],
              },
            },
            sideTwo: {
              order: "order-2",
              data: {
                Pics: {
                  img: images.innerhms.innerhms2,
                  alt: "vaidyo",
                },
              },
            },
          },
        },
        {
          id: 3,
          content: {
            sideOne: {
              order: "order-2",
              content: {
                Heading: {
                  SectionTitle: "The Advantages of Vaidyo’s HMS",
                  align: "start",
                },
                Text: [
                  {
                    value:
                      "Time saving latest Technology & Avoids human errors by Improved Efficiency,Scope for Error is reduced.Saving the insurance details for future use and monitoring bill payments.",
                  },
                  {
                    value:
                      "Proper access to patient data with correct patient history,Improved patient care and Increased Data security.Improved Audit controls and policy compliance.",
                  },
                  {
                    value:
                      " Acquiring an automated HMS is simple, what with the wide range of companies innovating various technologies to fulfill the varied requirements of the healthcare industry.",
                  },
                ],
              },
            },
            sideTwo: {
              order: "order-1",
              data: {
                Pics: {
                  img: images.innerhms.innerhms3,
                  alt: "vaidyo",
                },
              },
            },
          },
        },
        {
          id: 4,
          content: {
            sideOne: {
              order: "order-1",
              content: {
                Heading: {
                  SectionTitle: "Features of Vaidyo’s HMS ",
                  align: "start",
                },
                Text: [
                  {
                    value:
                      "If a hospital has a website, Vaidyo's HMS appointment widgets will be connected so that patients may easily make online appointments when they visit the hospital's website.",
                  },
                  {
                    value:
                      "Billing is integrated with treatments, lab work, and radiology in Vaidyo's HMS. Upon authorization, alerts will be delivered. Automatic dues collection, pre- and post-consultation billing options.",
                  },
                  {
                    value:
                      "The HMS of Vaidyo also administers recently and frequently used medications. Create a setting that allows patients to receive SMS prescriptions and see what medications are available in the pharmacy.",
                  },
                ],
              },
            },
            sideTwo: {
              order: "order-2",
              data: {
                Pics: {
                  img: images.innerhms.innerhms4,
                  alt: "vaidyo",
                },
              },
            },
          },
        },
        {
          id: 5,
          content: {
            sideOne: {
              order: "order-2",
              content: {
                Heading: {
                  SectionTitle: "About Vaidyo HMS",
                  align: "start",
                },
                Text: [
                  {
                    value:
                      "Vaidyo’s HMS helps build a centralized platform for managing operations, allowing hospitals to streamline their administrative processes. It ensures consistency across departments. This can improve efficiency, reduce errors, and better overall patient care. ",
                  },
                  {
                    value:
                      "Vaidyo’s HMS can help reduce medical errors by providing doctors and nurses with up-to-date patient information. It minimizes the risk of misdiagnosis, incorrect treatment, or adverse drug interactions.",
                  },
                 
                ],
              },
            },
            sideTwo: {
              order: "order-1",
              data: {
                Pics: {
                  img: images.innerhms.innerhms5,
                  alt: "vaidyo",
                },
              },
            },
          },
        },
      ],
      FAQSection: {
        Heading: {
          SectionTitle: "Any Questions? Find here.",
          SubHeading: "",
          align: "center",
        },
        image: {
          img: images.innerhms.innerhms3,
          alt: "vaidyo",
        },
        Questions: [
          {
            Question: "Does Vaidyo HMS provides training? ",
            Answer:
              "Yes, Vaidyo HMS provides training to all users as per the defined user role such as: doctors, nurses, executives, lab technicians, billing and finance, HR, etc. Apart from practical in-person training, it also offers help manuals and video tutorials for better understanding and improved efficiency. ",
          },
          {
            Question: "Is there any specific knowledge required for using Vaidyo HMS?",
            Answer:
              "No, there is NO such requirement for using Vaidyo HMS. As the application is developed in a user-friendly structure, even a novice user can easily operate the system.",
          },
          {
            Question:
              "What kind of hardware installations are required ?",
            Answer:
              "For a cloud-based services, Prior to the installation of vaidyo HMS, you need to make sure that the computers, networking, and internet connection are available and operational.             The highly experienced Vaidyo team at is available to help you in analyzing your current setup and suggesting new equipment’s installation in a cost effective manner. ",
          },
      
        ],
      },
      PricingSection: {
        Heading: {
          SectionTitle: "Designed for business teams like yours",
          SubHeading:
            "Here at Flowbite we focus on markets where technology, innovation, and capital can unlock long-term value and drive economic growth.",
          align: "center",
        },
        Cards: [
          {
            id: 1,
            Package: "Starter",
            Description: "Best option for personal use & for your next project",
            Pricing: {
              Price: "$29",
              Tenure: "/month",
            },
            CheckList: [
              {
                id: 1,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 2,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 3,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 4,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 5,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 6,
                icon: images.icons.check,
                text: "Individual configuration",
              },
            ],
            Buttons : {
                id : 1,
                path : '/',
                link : 'Get Started'
            }
          },
          {
            id: 1,
            Package: "Individual",
            Description: "Best option for personal use & for your next project",
            Pricing: {
              Price: "$99",
              Tenure: "/month",
            },
            CheckList: [
              {
                id: 1,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 2,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 3,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 4,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 5,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 6,
                icon: images.icons.check,
                text: "Individual configuration",
              },
            ],
            Buttons : {
                id : 1,
                path : '/',
                link : 'Get Started'
            }
          },
          {
            id: 1,
            Package: "Professional",
            Description: "Best option for personal use & for your next project",
            Pricing: {
              Price: "$199",
              Tenure: "/month",
            },
            CheckList: [
              {
                id: 1,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 2,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 3,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 4,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 5,
                icon: images.icons.check,
                text: "Individual configuration",
              },
              {
                id: 6,
                icon: images.icons.check,
                text: "Individual configuration",
              },
            ],
            Buttons : {
                id : 1,
                path : '/',
                link : 'Get Started'
            }
          },
        ],
      },
    },
  },
];
export default ProductData;
